import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskGettingStartedSlaEditRoute: InvariantJiraRoute = {
	name: 'servicedesk-getting-started-sla-edit',
	path: '/jira/servicedesk/projects/:projectKey/getting-started/sla/custom/:id/edit',
	exact: true,
};
